import { NumberIdentity, Version } from "@ascend-ltd/logic-helpers";
import { z } from "zod/v4";
import { OfficeId } from "../office";
const OfficeGroupIdSchema = NumberIdentity.schema.brand();
export const OfficeGroupId = {
    schema: OfficeGroupIdSchema,
    of: (id) => OfficeGroupId.schema.parse(id),
};
const OfficeGroupNameSchema = z.object({
    name: z.string().min(1),
    kana: z.string().min(1).optional(),
});
export const OfficeGroupName = {
    schema: OfficeGroupNameSchema,
};
const OfficeGroupSchema = z.object({
    id: OfficeGroupId.schema,
    name: OfficeGroupName.schema,
    officeIds: z.array(OfficeId.schema).min(1, "営業所を1つ以上選択してください"),
    version: Version.schema,
});
export const OfficeGroupEntity = {
    schema: OfficeGroupSchema,
    reconstruct: (args) => OfficeGroupEntity.schema.parse(args),
    create: (args) => OfficeGroupEntity.schema.parse({
        ...args,
        id: NumberIdentity.generate(),
        version: Version.initial(),
    }),
    update: (entity, args) => OfficeGroupEntity.schema.parse({
        ...entity,
        name: args.name,
        officeIds: args.officeIds,
    }),
};
//# sourceMappingURL=office-group-entity.js.map